import getArg from './args';
import { getWindow } from './html';

const alreadyLoaded = { val: false };
export default (callback) => {
  if (!getArg('browser')) {
    return;
  }
  const loadScript = getWindow().loadScript; // eslint-disable-line
  if (!alreadyLoaded.val) {
    loadScript({ src: 'https://ssl.ditonlinebetalingssystem.dk/integration/ewindow/paymentwindow.js', id: 'paymentScript' }).then(
      () => {
        alreadyLoaded.val = true;
        callback(window.PaymentWindow); // eslint-disable-line
      },
    );
  } else {
    callback(window.PaymentWindow); // eslint-disable-line
  }
};
